import styled from 'styled-components';
import {ContainerRef} from '../styles';

export const Container = styled(ContainerRef)``;